<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="card pb-s">
    <div
      v-if="content.picture"
      class="card__picture mb-s"
      :class="{
        'has-white': content.hasWhiteBackground,
      }"
    >
      <GPicture class="cover" :content="content.picture" sizes="60vw" />
    </div>

    <div v-else class="card__picture mb-s">
      <SvgSprite class="icon" symbol="ui-image" size="40" aria-hidden="true" />
    </div>

    <div v-if="content.date" class="card__date tiny-body-text">
      {{ content.date }}
    </div>
    <h3 class="card__title h4" v-html="content.title"></h3>
    <div
      v-if="content.brand"
      class="card__brand body-text"
      v-html="content.brand"
    ></div>

    <!-- Actions -->
    <!-- Open Modal with details -->
    <button v-if="content.pictures" class="card__link" @click="openModal()">
      <span class="h-visually-hidden">Open gallery</span>
    </button>

    <!-- Open Full Link -->
    <RouterLink
      v-if="content.link"
      :to="content.link.url"
      :target="content.link.target"
      class="card__link"
    >
      <span class="h-visually-hidden">{{
        content.link.title || content.title
      }}</span>
    </RouterLink>

    <!-- Open Link Url -->
    <RouterLink v-if="content.url" :to="content.url" class="card__link">
      <span class="h-visually-hidden">{{ content.title }}</span>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '@/stores/ui'

import type { PropType } from 'vue'
import type { Card } from '@/types'

const props = defineProps({
  content: {
    type: Object as PropType<Card>,
    required: true,
  },
})

const uiStore = useUiStore()

const openModal = () => {
  uiStore.modalVisible = true
  uiStore.modalContent = props.content as Card
}
</script>

<style lang="scss" scoped>
$bp: 'l';

.card {
  position: relative;
  overflow: hidden;
}

.card__picture {
  @extend %br-default;

  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 40/52;
  background-color: $c-beige;
  border: 1px solid $c-grey-light;

  .icon {
    @include center-xy;

    fill: $c-grey-dark;
  }

  &.has-white {
    background-color: $c-white;

    :deep(img) {
      /* stylelint-disable-next-line declaration-no-important */
      object-fit: contain !important;
    }
  }

  :deep(img) {
    transition: transform 0.3s ease-out;
  }

  .card:hover & {
    :deep(img) {
      transform: scale(1.1);
      transform-origin: center;
    }
  }
}

.card__date {
  color: $c-grey-medium;
}

.card__title {
  margin-top: 1.6rem;
  margin-bottom: 0;
  padding-right: 2.4rem;
}

.card__date + .card__title {
  margin-top: 0;
}

.card__brand {
  margin-top: -0.4rem;
  padding-right: 2.4rem;
  color: $c-grey-dark;
}

.card__link {
  @extend %button-nostyle;
  @include get-all-space;

  cursor: pointer;
}
</style>
